export class ConfigProxyHandler {
    private previousPath: string[] = [];

    public constructor(previousPath: string[] = []) {
        this.previousPath = previousPath;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get(target: any, property: string): any {
        const propertyPath = [...this.previousPath, property];
        if (!target[property]) {
            console.warn(`Trying to reference undefined config field ${propertyPath.join('.')}`);
            return undefined;
        }

        if (typeof target[property] === 'object') {
            return new Proxy(target[property], new ConfigProxyHandler(propertyPath));
        }

        return target[property];
    }
}

